module.exports = "https://cdn.thelire.com/ins/resource/banner_tab5_exclusivevippackages_1@3x.f38b6000f70dd57c5ae20c200158bbc6.png";